document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tab-link").forEach((tabLink) => {
    tabLink.addEventListener("click", (event) => {
      event.preventDefault();

      document.querySelectorAll("[data-active]").forEach((activeElement) => {
        activeElement.removeAttribute("data-active");
      });

      event.target.setAttribute("data-active", "true");
      document.querySelector(event.target.getAttribute("href")).setAttribute("data-active", "true");
    });
  });
});
